export var AfriexUnblockReason;
(function (AfriexUnblockReason) {
    AfriexUnblockReason["KYC_IN_PLACE"] = "KYC_IN_PLACE";
    AfriexUnblockReason["EDD_PROVIDED"] = "EDD_PROVIDED";
    AfriexUnblockReason["WATCHLIST_MATCH_CLEARED"] = "WATCHLIST_MATCH_CLEARED";
    AfriexUnblockReason["DISPUTE_RESOLVED"] = "DISPUTE_RESOLVED";
    AfriexUnblockReason["DISPUTE_FUNDS_RECOVERED_FROM_WALLET"] = "DISPUTE_FUNDS_RECOVERED_FROM_WALLET";
    AfriexUnblockReason["OTHERS"] = "OTHERS";
    AfriexUnblockReason["CARDS_REVIEWED_ON_STRIPE"] = "CARDS_REVIEWED_ON_STRIPE";
    AfriexUnblockReason["DATE_OF_BIRTH_UPDATED"] = "DATE_OF_BIRTH_UPDATED";
    AfriexUnblockReason["LEGAL_NAMES_UPDATED"] = "LEGAL_NAMES_UPDATED";
})(AfriexUnblockReason || (AfriexUnblockReason = {}));
//# sourceMappingURL=AfriexUnblockReason.js.map